import { render, staticRenderFns } from "./VertTabs.vue?vue&type=template&id=4727e783&"
import script from "./VertTabs.vue?vue&type=script&lang=js&"
export * from "./VertTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports